// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2XHoE","overflowing":"ReadFullNote_overflowing__1bPAu"};